import metaApi from './meta';
import casesApi from './cases';
import customersApi from './customers';
import riskProfileApi from './riskProfile';
import existingPoliciesApi from './existingPolicies';
import contributionsApi from './contributions';
import withdrawalsApi from './withdrawals';
import policiesActionsApi from './policyActions';
import fundsApi from './funds';
import policiesApi from './policies';
import recommendationApi from './recommendations';
import advisorCharges from './advisorCharges';
import userApi from './user';
import chartsApi from './charts';
import cipApi from './cip';
import ipsApi from './ips';
import platformApi from './platform';
import questionnaresAi from './questionnaire';
import firmApi from './firm';
import modelPortfolioApi from './modelPortfolios';
import messagesApi from './messages';
import intelifloApi from './inteliflo';
import providerPlatformChargesApi from './providerPlatformCharges';
import capacityForLossApi from './capacityForLoss';
import forecastReturnsApi from './forecastReturns';
import benchmarksApi from './benchmarks';
import systemUpdatesApi from './systemUpdates';
import glossaryApi from './glossary';
import investmentResearchApi from './investmentResearch';
import investmentAnalyserApi from './investmentAnalyser';
import mpsHub from './mpsHub';
import palette from './palette';
import riskDescriptions from './riskDescriptions';

export default {
  ...metaApi,
  ...casesApi,
  ...customersApi,
  ...riskProfileApi,
  ...existingPoliciesApi,
  ...fundsApi,
  ...contributionsApi,
  ...policiesActionsApi,
  ...fundsApi,
  ...policiesApi,
  ...recommendationApi,
  ...advisorCharges,
  ...userApi,
  ...chartsApi,
  ...cipApi,
  ...ipsApi,
  ...platformApi,
  ...questionnaresAi,
  ...firmApi,
  ...modelPortfolioApi,
  ...messagesApi,
  ...intelifloApi,
  ...providerPlatformChargesApi,
  ...capacityForLossApi,
  ...forecastReturnsApi,
  ...benchmarksApi,
  ...systemUpdatesApi,
  ...glossaryApi,
  ...withdrawalsApi,
  ...investmentResearchApi,
  ...investmentAnalyserApi,
  ...mpsHub,
  ...palette,
  ...riskDescriptions
};
